export var IdMenuBalancing;
(function (IdMenuBalancing) {
    IdMenuBalancing[IdMenuBalancing["FarmManagement"] = 1] = "FarmManagement";
    IdMenuBalancing[IdMenuBalancing["Build"] = 2] = "Build";
    IdMenuBalancing[IdMenuBalancing["ContextMenu"] = 3] = "ContextMenu";
    IdMenuBalancing[IdMenuBalancing["RankingMenu"] = 4] = "RankingMenu";
    IdMenuBalancing[IdMenuBalancing["Quest"] = 5] = "Quest";
    IdMenuBalancing[IdMenuBalancing["Nursery"] = 7] = "Nursery";
    IdMenuBalancing[IdMenuBalancing["DogHouse"] = 8] = "DogHouse";
    IdMenuBalancing[IdMenuBalancing["Market"] = 10] = "Market";
    IdMenuBalancing[IdMenuBalancing["Tournament"] = 11] = "Tournament";
    IdMenuBalancing[IdMenuBalancing["WaterTower"] = 12] = "WaterTower";
    IdMenuBalancing[IdMenuBalancing["Library"] = 6] = "Library";
    IdMenuBalancing[IdMenuBalancing["SettingsMenu"] = 14] = "SettingsMenu";
    IdMenuBalancing[IdMenuBalancing["ThemedEvent"] = 15] = "ThemedEvent";
    IdMenuBalancing[IdMenuBalancing["CoopMenu"] = 16] = "CoopMenu";
    IdMenuBalancing[IdMenuBalancing["CollectMenu"] = 17] = "CollectMenu";
    IdMenuBalancing[IdMenuBalancing["Store"] = 9] = "Store";
    IdMenuBalancing[IdMenuBalancing["ExternalBarn"] = 100] = "ExternalBarn";
})(IdMenuBalancing || (IdMenuBalancing = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdMenuBalancing.ts
// module id = 81
// module chunks = 3